<script setup>
import Validation from '@/classes/global/Validation';

const emits = defineEmits(['input', 'update:validationFail'])

const props = defineProps({

  modelValue: {},

  height: {type: Number, default: 60},
  width: {type: Number, default: 300},
  validationFail: {type: Object, default: {}},
  validationText: {type: Array, default: ['Required']},
  placeholder: {type: String, default: 'Enter Text'},
  readonly: {type: Boolean, default: false}
})

function performEmits(value) {

  emits('update:validationFail', new Validation());
  emits('input', value);
}

</script>
<template>
  <div class="cmp-text-area">
    <textarea
        :value="modelValue"
        @input="performEmits($event.target.value)"
        :readonly="props.readonly"
        class="global-textarea"
        :placeholder="props.placeholder"
        :class="{'validation-fail' :validationFail.value }"
        :style="{height: height + 'px', width: width + 'px'}"/>
    <div v-if="validationFail.value" class="validation-message">
      {{ validationText[validationFail.messageNumber] }}
    </div>
  </div>
</template>

<style scoped>

.cmp-text-area {
  position: relative;
  /*z-index: 9999;*/
}

.validation-message {
  position: absolute;
  font-family: Arial;
  font-size: 10px;
  color: var(--required-field);
  bottom: 2px;
  background: #fdfdfd;
  width: fit-content;
  padding: 0 3px 0 3px;
  line-height: normal;
  border-radius: 6px;
}

.validation-fail {
  border: 1px dotted var(--required-field)
}


</style>
